import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@clerk/clerk-react';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { GET_ORGANIZATION_RELATIONS_QUERY_KEY } from '@/state/queries/organizations/use-get-organization-relations.ts';
import type { OrganizationRelationListItemDto } from '@/types/dtos/organizations/response/organization-relation.dto.ts';
import type { PatchOrganizationMembershipRolesRequestDto } from '@/types/dtos/organizations/request/patch-organization-membership-roles.dto.ts';

export const usePatchOrganizationMembershipRolesMutation = (organizationId: string | undefined) => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      relationId,
      body,
    }: {
      relationId: string;
      body: PatchOrganizationMembershipRolesRequestDto;
    }): Promise<OrganizationRelationListItemDto> => {
      const token = await getToken();
      const url = `${import.meta.env.VITE_API_URL}/organizations/${organizationId}/relations/${relationId}/roles`;
      return sendJSONRequest({
        url,
        method: METHOD.PATCH,
        body,
        token: token ?? '',
      }) as Promise<OrganizationRelationListItemDto>;
    },
    onSuccess: () => {
      if (organizationId) {
        void queryClient.invalidateQueries({ queryKey: [GET_ORGANIZATION_RELATIONS_QUERY_KEY, organizationId] });
      }
    },
  });
};
